<template>
  <div id="app">
    <div class="d-flex justify-content-between logo-sidebar-furia">
      <img
        :src="logo"
        class="img-fluid logo-desktop"
        alt=""
        style="
          height: 55px;
          margin-left: 7px;
          margin-top: 7px;
          border-radius: 18px 5px 5px 18px;
        "
      />
      <!-- <img :src=logo class="img-fluid logo-desktop" alt="" style="height: 67px; border-radius: 18px 5px 5px 18px;"> -->
      <!-- <img :src=logo class="img-fluid logo-mobile" alt=""> -->
    </div>
    <transition>
      <router-view />
    </transition>
    <template v-if="$store.state.evento.idiomas && $store.state.step == -1">
      <div class="using-social-header">{{ $t("common.lang") }}</div>
      <LocaleSwitcher />
    </template>
    <div class="copyrights">
      <small
        >Powered by GloBiz.com
        <br />
        &copy; 2023 - {{ year }}</small
      >
    </div>
    <vs-dialog blur v-model="dialogoLogout">
      <!-- prevent-close not-close  -->
      <template #header>
        <div class="modal-dialog modal-sm">
          <div class="modal-content">
            <div class="modal-header">
              <i class="material-icons">logout</i>
            </div>
            <h4 class="not-margin center">{{ $t("common.msg-logout") }}</h4>
            <div class="not-margin center">
              <vs-button
                success
                size="xl"
                flat
                :active="true"
                @click="logout()"
                animation-type="scale"
                >{{ $t("common.go-out") }}</vs-button
              >
              <vs-button
                success
                size="xl"
                flat
                :active="false"
                @click="cancelarLogout()"
                animation-type="scale"
                >{{ $t("common.cancel") }}</vs-button
              >
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="footer-dialog"></div>
      </template>
    </vs-dialog>

    <!-- @close="close()" -->
    <vs-dialog blur v-model="thisAskForPass">
      <!-- prevent-close not-close -->
      <!-- <template #header>
        <h4 class="not-margin">{{ $t("access.enter-credentials") }}</h4>
      </template> -->
      <div class="modal-header">
        <i class="material-icons" style="font-size: 44px">vpn_key</i>
      </div>
      <h3>{{ $t("access.ya_existe_cuenta") }}</h3>
      <!-- <div class="text-center" style="margin-bottom:10px;">
      <b-link :href="url_registro" target="_blank">{{$t('access.register')}}</b-link>
      </div> -->
      <form>
        <div class="con-form">
          <vs-input
            hidden
            ref="username"
            autocomplete="username"
            v-model="email"
          >
          </vs-input>
          <vs-input
            type="password"
            v-model="pwd"
            autocomplete="current-password"
            :placeholder="$t('access.password')"
            :visiblePassword="hasVisiblePassword"
            v-on:keyup.enter="access()"
          >
            <template #icon>
              <i class="material-icons">lock</i>
            </template>
          </vs-input>
          <vs-tooltip right>
            <span
              style="
                position: relative;
                display: inline;
                top: -32px;
                left: 165px;
              "
              @click="hasVisiblePassword = !hasVisiblePassword"
            >
              <i v-if="!hasVisiblePassword" class="material-icons"
                >visibility_on</i
              >
              <i v-else class="material-icons">visibility_off</i>
            </span>
            <template #tooltip>
              {{ $t("access.show-hide-password") }}
            </template>
          </vs-tooltip>
          <div class="flex">
            <!-- <vs-checkbox v-model="chk_stayconnected"
              >{{$t('access.stay-connected')}}</vs-checkbox
            > -->
            <div class="text-center">
              <a :href="url_recupera_pass" target="_blank">{{
                $t("access.password-recover")
              }}</a>
            </div>
          </div>
        </div>
      </form>
      <template #footer>
        <div class="footer-dialog">
          <vs-button @click="access()">{{ $t("access.login") }}</vs-button>
        </div>
      </template>
    </vs-dialog>
  </div>
</template>

<script>
import store from "@/store.js";
import i18n, { loadLocaleMessages } from "@/i18n";
import {
  setDocumentDirectionPerLocale,
  setDocumentLang,
  setDocumentTitle,
} from "@/util/i18n/document";
import LocaleSwitcher from "./components/LocaleSwitcher.vue";
const { locale } = i18n;

loadLocaleMessages(locale).then(() => {
  setDocumentLang(locale);
  setDocumentDirectionPerLocale(locale);
  setDocumentTitle(i18n.t("app.title"));
});

export default {
  name: "app",
  components: {
    LocaleSwitcher,
  },
  data() {
    return {
      store,
      dialogoLogout: false,
      email: this.$store.state.usr.email,
      pwd: "",
      hasVisiblePassword: false,
    };
  },
  mounted() {
    // console.log(this.$route.params.ide)
    // if (this.$route.params.ide && this.$route.params.ide != 0) {
    //   console.log('llama a recuperar info evento')
    //   this.RecuperarInfoEventoyPlan(this.$route.params.ide, this.$route.param.pli)
    // } else {
    //var msg = "Debe indicarse el evento sobre el cuál trabajar";
    //this.$router.push("/pages/not-authorized");
    //   name: "NoAuth",
    //   props: { msg: msg }
    // });
    // }
  },
  computed: {
    url_recupera_pass() {
      return this.$websiteFront + "/registro/recuperarpass.php";
    },
    year() {
      let fecha = new Date();
      let options = { timeZone: "UTC", year: "numeric" }; // Importante colocar el timezone para q convierta desde la timezone local a la timezone UTC 0, q es la timezone q tenia la variable myDate originalmente
      return fecha.toLocaleDateString("es-ES", options);
    },
    thisAskForPass: {
      // getter
      get: function () {
        if (this.$store.state.askForPass) {
          // eslint-disable-next-line
          this.email = this.$store.state.usr.email;
          return true;
        } else {
          return false;
        }
      },
      // setter (cuando el dialog se cierra con click en la x, o pulsando la tecla esc, o click fuera del cuadro
      // el dialog "setea" la propiedad computada a false) y ahi se dispara el método close
      set: function (newValue) {
        if (!newValue) {
          this.close();
        }
      },
    },
    failedLogin() {
      if (this.$store.state.failedLogin) {
        return true;
      } else {
        return false;
      }
    },
    failedReg() {
      if (this.$store.state.regComplete == 0) {
        return true;
      } else {
        return false;
      }
    },
    completedReg() {
      if (this.$store.state.regComplete == 1) {
        return true;
      } else {
        return false;
      }
    },
    logo() {
      if (this.$store.state.evento.LogoPlataforma) {
        return (
          this.$websiteGlobiz +
          "/events/admin/img/" +
          this.$store.state.evento.LogoPlataforma
        );
      } else {
        return (
          this.$websiteGlobiz + "/common/images/logo-rueda_de_negocios.svg"
        );
      }
    },
  },
  watch: {
    // askForPass() {
    //     // let self = this
    //     this.$nextTick().then(function () {
    //       // self.$refs.usernameinput.$el.focus()
    //     })
    // },
    failedLogin() {
      if (this.failedLogin) {
        this.$vs.notification({
          icon: "<i class='bx bx-error' ></i>",
          color: "danger",
          position: "top-center",
          progress: "auto",
          duration: 3000,
          border: "danger",
          title: "Error",
          text: "Login fallido",
        });
        store.commit("failedLogin", false);
      }
    },
    failedReg() {
      if (this.failedReg) {
        this.$vs.notification({
          icon: "<i class='bx bx-error' ></i>",
          color: "danger",
          position: "top-center",
          progress: "auto",
          duration: 3000,
          border: "danger",
          title: this.$t("common.lbl_error"),
          text: this.$t("error.lbl_no_completo_regitro"),
        });
      }
    },
    completedReg() {
      if (this.completedReg) {
        // La notificación de registro completo la muestra sólo si no va a tener que seguir con el pago
        if (
          this.state.evento.TieneCosto !== "1" ||
          this.state.evento.ModuloCobranzaActivo !== "1"
        ) {
          this.$vs.notification({
            icon: "<i class='bx bx-error' ></i>",
            color: "success",
            position: "top-center",
            progress: "auto",
            duration: 3000,
            border: "success",
            title: this.$t("common.lbl_felicita"),
            text: this.$t("common.lbl_registro_completo"),
          });
        }
      }
    },
  },
  methods: {
    // LOGIN - LOGOUT
    // logout() {
    //   this.$store.dispatch("logout")
    // },
    // cancelarLogout() {
    //   this.$store.dispatch("desactivarDialogoLogout")
    // },
    access() {
      var datosLogin = {
        ide: this.$route.params.ide,
        username: this.email,
        passwd: this.pwd,
        firstLogin: false,
      };
      this.$store.dispatch("login", datosLogin);
      store.commit("nextStep", 0);
    },
    close() {
      // console.log("close")
      // store.commit('askForPass', false)
      store.commit("clearUsrData", this.username);
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  color: var(--iq-primary-dark);
  margin-top: 60px;
}

pre {
  text-align: left;
}

input {
  height: 30px;
  font-size: 20px;
}

form {
  margin: 0 auto;
  max-width: 500px;
}
.vs-dialog {
  width: 400px;
}
/* .badge-error {
  border-radius: 15px;
  padding: 0 5px;
  color: whitesmoke;
	color: #fff;
	background-color: #97b4b8
  background-color:  darkred;
  font-style: italic;
} */
/* .vs-input {
  border: 2px solid transparent;
  background: rgba(var(--vs-gray-2), 1);
  color: rgba(var(--vs-text), 1);
  padding: 7px 13px;
  border-radius: inherit;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
  padding-left: 10px;
  width: 100%;
  margin: 5px 0;
} */
</style>

